/**
 * documentChangeTypes.js
 * Created by calhosh on 5/19/2020.
 */

import * as types from '../actions/actiontypes';
import initialstate from './initialstate';

export default function documentChangeTypesReducer(
	state = initialstate.documentChangeTypes,
	action
) {
	switch (action.type) {
		case types.GET_DOCUMENT_CHANGE_TYPES:
			return action.response || state;
		default:
			return state;
	}
}
